import * as React from "react";
import { makeStyles} from "@mui/styles";
import List from "@mui/material/List";

const useStyles = makeStyles(() => ({
  list: {
    width: 400
  }
}));

const SidebarList = ({ children, onItemSelected }) => {
  const classes = useStyles();

  return (
    <List className={classes.list}>
      {React.Children.toArray(children).map((item, index) =>
        React.cloneElement(item, {
          key: index,
          index,
          onListItemSelected: (index) => onItemSelected(index)
        })
      )}
    </List>
  );
};

export default SidebarList;
